export default __webpack_public_path__ + "static/media/background.97a51f81.jpeg";